export default __webpack_public_path__ + "static/media/bg-status-cotacao.c06a47f4.webp";